import script from "./AppSlippageForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSlippageForm.vue?vue&type=script&setup=true&lang=ts"

import "./AppSlippageForm.vue?vue&type=style&index=0&id=51555936&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51555936"]])

export default __exports__